import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { apiSoftDeleteUser } from '@services/ManageUserOperator/UserOperatorServices';
import { showSuccess, showError } from '@components/notification';

const SoftDeleteUserModal = ({ open, onClose, userInfo, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleSoftDelete = async () => {
    try {
      setLoading(true);
      await apiSoftDeleteUser(userInfo.id);
      showSuccess({ message: 'Xóa người dùng thành công!' });
      onClose();
      onSuccess();
    } catch (error) {
      showError(error?.message || 'Không thể xóa người dùng');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#e11d48', marginRight: 8 }} />
          Xác nhận xóa người dùng
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Hủy
        </Button>,
        <Button key="delete" type="primary" danger loading={loading} onClick={handleSoftDelete}>
          Xóa
        </Button>
      ]}>
      <p>
        Bạn có chắc chắn muốn xóa người dùng <strong>{userInfo?.user_name}</strong>?
      </p>
      <p style={{ color: 'var(--muted)', fontSize: '14px' }}>
        Sau khi xóa, người dùng này sẽ bị vô hiệu hóa và không thể đăng nhập. Dữ liệu lịch sử sẽ
        được bảo toàn.
      </p>
    </Modal>
  );
};

export default SoftDeleteUserModal;
